import * as React from "react";
import {
  MdDirectionsCar,
  MdFlight,
  MdKingBed,
  MdLocalActivity,
  MdLuggage,
  MdPercent,
  MdTravelExplore,
} from "react-icons/md";
import { cn } from "../../lib/utils";
import {
  COMING_SOON_BUBBLE_POSITIONS,
  COMING_SOON_STYLES,
} from "./constants";
import type { ComingSoonProps } from "./types";

const BUBBLES: Array<{
  key: keyof typeof COMING_SOON_BUBBLE_POSITIONS;
  label: string;
  Icon: React.ComponentType<{ className?: string }>;
}> = [
  { key: "luggage", label: "Luggage", Icon: MdLuggage },
  { key: "flight", label: "Flight", Icon: MdFlight },
  { key: "kingBed", label: "Hotel", Icon: MdKingBed },
  { key: "localActivity", label: "Event", Icon: MdLocalActivity },
  { key: "globe", label: "Destinations", Icon: MdTravelExplore },
  { key: "directionsCar", label: "Car rental", Icon: MdDirectionsCar },
  { key: "percent", label: "Deals", Icon: MdPercent },
];

function Orbits() {
  return (
    <svg
      className={COMING_SOON_STYLES.orbits}
      viewBox="0 0 1512 560"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <g transform="translate(756 300) rotate(24.81)">
        <ellipse
          cx="0"
          cy="0"
          rx="270"
          ry="97"
          fill="none"
          stroke="#0C5DB9"
          strokeWidth="1.5"
          strokeDasharray="2 8"
          opacity="0.55"
        />
      </g>
      <g transform="translate(720 280) rotate(-8.13)">
        <ellipse
          cx="0"
          cy="0"
          rx="360"
          ry="200"
          fill="none"
          stroke="#F08B31"
          strokeWidth="1.5"
          strokeDasharray="2 10"
          opacity="0.7"
        />
      </g>
    </svg>
  );
}

export const ComingSoon = React.forwardRef<HTMLElement, ComingSoonProps>(
  (
    {
      className,
      backgroundImageUrl,
      logoImageUrl,
      primaryText = "Coming",
      secondaryText = "Soon",
      ...props
    },
    ref
  ) => {
    return (
      <section
        ref={ref}
        className={cn(COMING_SOON_STYLES.root, className)}
        {...props}
      >
        <div className={COMING_SOON_STYLES.frame}>
          <img
            src={backgroundImageUrl}
            alt=""
            className={COMING_SOON_STYLES.background}
            loading="eager"
          />

          {logoImageUrl && (
            <div className={COMING_SOON_STYLES.logoWrapper}>
              <img
                src={logoImageUrl}
                alt=""
                className={COMING_SOON_STYLES.logo}
              />
            </div>
          )}

          <Orbits />

          <div className={COMING_SOON_STYLES.content}>
            <span className={COMING_SOON_STYLES.primaryText}>
              {primaryText}
            </span>
            <span className={COMING_SOON_STYLES.secondaryText}>
              {secondaryText}
            </span>

            {BUBBLES.map(({ key, label, Icon }) => (
              <div
                key={key}
                className={cn(
                  COMING_SOON_STYLES.bubble,
                  COMING_SOON_BUBBLE_POSITIONS[key]
                )}
                role="img"
                aria-label={label}
              >
                <Icon className={COMING_SOON_STYLES.bubbleIcon} />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }
);

ComingSoon.displayName = "ComingSoon";
